import { render } from "./RichEditor.vue?vue&type=template&id=e216d8f0"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"

import "@vueup/vue-quill/dist/vue-quill.snow.css?vue&type=style&index=0&lang=css"
import "./RichEditor.vue?vue&type=style&index=1&id=e216d8f0&lang=css"

import exportComponent from "C:\\Users\\gerardo\\source\\repos\\Dorapp Web\\Dorapp Web\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__